<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title" :name="item.value" :key="item.value">
        <ComList :list-type="item.value" :ref="'ComList' + item.value" :dataSource="item.dataSource" :total="item.total"
          @search="search" :warehouseData="warehouseData"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { transferList, deliveryList } from "@/apis/outDomestic";
import ComList from "@/views/outOfDomestic/domesticShipment/transfer/components/ComTable";
import {warehouseList} from "@/apis/configure";

export default {
  title: "调拨出库",
  name: "transfer", // 调拨出库
  components: {
    ComList,
  },
  data() {
    return {
      activeName: "0",
      warehouseData:[],
      comList: [
        {
          title: "仓库调拨",
          value: "0",
          dataSource: [],
          total: 0,
          func: "getTransfer",
        },
        {
          title: "发货单列表",
          value: "1",
          dataSource: [],
          total: 0,
          func: "getDelivery",
        },
      ],
    };
  },
  mounted() {
    this.getTransfer();
    this.getWarehouse()
  },
  methods: {
    handleClick(res) {
      let index = res.index;
      this[this.comList[index].func]();
    },
    getWarehouse() {
      warehouseList().then(({ code, data }) => {
        if (code === 0) {
          this.warehouseData = data;
        }
      });
    },
    getTransfer(formInline) {
      let params = formInline || {
        pageNum: 1,
        pageSize: 10,
      };
      transferList(params).then(({ code, data }) => {
        if (code === 0) {
          this.comList[0].dataSource = data.records;
          this.comList[0].total = data.total;
        }
      });
    },
    getDelivery(formInline) {
      let params = formInline || {
        pageNum: 1,
        pageSize: 10,
      };
      deliveryList(params).then(({ code, data }) => {
        if (code === 0) {
          this.comList[1].dataSource = data.records;
          this.comList[1].total = data.total;
        }
      });
    },
    search(emitData) {
      if (emitData) {
        this[this.comList[emitData.listType].func](emitData.formInline);
      }
    },
  },
};
</script>

<style scoped>
</style>
